var render = function render(){
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_vm.textarea ? _c('textarea', _vm._g(_vm._b({
    directives: [{
      name: "maska",
      rawName: "v-maska",
      value: _vm.mask,
      expression: "mask"
    }],
    class: (_class = {}, _class[_vm.$style.input] = true, _class[_vm.$style.error] = _vm.error, _class),
    attrs: {
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "autocomplete": _vm.autocomplete
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update', $event.target.value);
      }
    }
  }, 'textarea', _vm.$attrs, false), _vm.$listeners)) : _c('input', _vm._g(_vm._b({
    directives: [{
      name: "maska",
      rawName: "v-maska",
      value: _vm.mask,
      expression: "mask"
    }],
    class: (_class2 = {}, _class2[_vm.$style.input] = true, _class2[_vm.$style.error] = _vm.error, _class2),
    style: {
      background: _vm.changed ? _vm.changedColor : '#fff'
    },
    attrs: {
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "autocomplete": _vm.autocomplete
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update', $event.target.value);
      }
    }
  }, 'input', _vm.$attrs, false), _vm.$listeners)), _c('div', {
    class: _vm.$style.errorContainer
  }, [_vm.error ? _c('p', {
    staticClass: "tag-text",
    class: _vm.$style.errorMessage
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }